<div class="four wide column settings-side-menu">
  <!-- Mobile: dropdown to switch settings page (uses existing app-select for consistent styling) -->
  <div class="settings-side-menu-dropdown mobile only">
    <label>Settings</label>
    <app-select
      :items="selectItems"
      :value="selectedPage"
      @selected="onPageChange($event.id)">
    </app-select>
  </div>
  <!-- Desktop: vertical menu (hidden on mobile) -->
  <div class="ui left secondary vertical menu settings-side-menu-vertical mobile hidden">
    <router-link :to="{name: 'AccountSettings'}" tag="div" class="item" v-bind:class="{active:active_tab==='account'}" v-if="$store.getters['user/isAuthenticated'] && !$store.getters['user/isPlatformAdmin']"><a>Account</a></router-link>
    <router-link :to="{name: 'DisplaySettings'}" tag="div" class="item" v-bind:class="{active:active_tab==='display'}" v-if="$store.getters['user/isAuthenticated'] && !$store.getters['user/isPlatformAdmin']"><a>Display</a></router-link>
    <router-link :to="{name: 'CategorySettings'}" tag="div" class="item" v-bind:class="{active:active_tab==='category'}" v-if="$store.getters['user/isPlatformAdmin']"><a>Category</a></router-link>
    <router-link :to="{name: 'MaterialSettings'}" tag="div" class="item" v-bind:class="{active:active_tab==='material'}" v-if="$store.getters['user/isAuthenticated']"><a>Products</a></router-link>
    <router-link :to="{name: 'TaskSettings'}" tag="div" class="item" v-bind:class="{active:active_tab==='task'}"><a>Tasks</a></router-link>
  </div>
</div>
